import { useState } from "react";
import { createModel } from "hox";
import { homeService } from "./homeService";
import useGlobalModel from "@/model/globalModel";

export const useHomerModal = createModel(function () {
    const { setLoadingInfo } = useGlobalModel(() => [])
    const [loading, setLoading] = useState<boolean>(false);
    const [type, setType] = useState<string>('monthly');   //日期信息
    const [visitData, setVisitData] = useState<any[]>([]);
    const [shareData, setShareData] = useState<any[]>([]);
    const [orgInsertData, setOrgInsertData] = useState<any[]>([]);
    const [groupInsertData, setGroupInsertData] = useState<any[]>([]);

    const [shareRes, setShareRes] = useState<any>({});
    const [employeeData, setEmployeeData] = useState<any[]>([]);
    const [employeeValue, setEmployeeValue] = useState<string | undefined>(undefined);
    //访问量
    const loadVisit = async (type: string, orgCode: string) => {
        let { retData } = await homeService[type === "monthly" ? 'visitMonthly' : type === "quarterly" ? 'visitQuarterly' : 'visitYearly'](orgCode);
        setVisitData(retData ?? [])
    }
    //分享
    const loadShare = async (type: string, orgCode: string) => {
        let { retData } = await homeService[type === "monthly" ? 'shareMonthly' : type === "quarterly" ? 'shareQuarterly' : 'shareYearly'](orgCode);
        setShareRes(retData ?? {});
        let newEmployeeData = [];
        if (retData) {
            for (let prop in retData) {
                newEmployeeData.push({
                    label: prop,
                    value: prop
                })
            }
            // debugger;
            //切换季度 年度 分享的人员在选中的情况下保持不变
            let findE = newEmployeeData.find(item => item.label === employeeValue)?.label;
            handleEmployee(findE ? findE : newEmployeeData.length ? newEmployeeData[0].label : undefined, retData ?? {}, type)
        }
        setEmployeeData(newEmployeeData);
    }

    //新增管理公司统计
    const loadOrgInsert = async (type: string) => {
        // 这个接口需要后端代码需要重构  你先给隐藏掉 别让展示了
        // setOrgInsertData([]);
        // return;
        let { retData } = await homeService[type === "monthly" ? 'orgInsertMonthly' : type === "quarterly" ? 'orgInsertQuarterly' : 'orgInsertYearly']();
        setOrgInsertData(retData ?? [])
    }
    //名片新增分组统计
    const loadGroupInsert = async (type: string) => {
        let { retData } = await homeService[type === "monthly" ? 'groupInsertMonthly' : type === "quarterly" ? 'groupInsertQuarterly' : 'groupInsertYearly']();
        setGroupInsertData(retData ?? [])

    }
    const loadData = async (type: string, orgCode: string) => {
        setLoadingInfo({ loadingVisible: true, txt: "数据加载中..." })
        try {
            let res1 = await loadVisit(type, orgCode)
            let res2 = await loadShare(type, orgCode)
            let res3 = await loadOrgInsert(type)
            let res4 = await loadGroupInsert(type);
            setLoadingInfo({ loadingVisible: false, txt: "快速导入中" })
        } catch (err) {
            console.log(err);
            setLoadingInfo({ loadingVisible: false, txt: "快速导入中" })
        }
    }

    //分享人员变动
    const handleEmployee = (value: string | undefined, data = shareRes, oType = type) => {
        setEmployeeValue(value);
        if (value) {
            try {
                let newArr: any[] = [];
                //拿到个人的数据  去匹配月、季度、年 处理做展示
                let ownData = data[value] ?? [];
                //拿到对应日期的信息
                let dates = getDates(oType);
                if (ownData && ownData.length) {
                    let tempInfo = ownData[0];
                    dates.forEach(item => {
                        //根据日期匹配填充没有日期的默认数据
                        let findObj = ownData.find((info: any) => {
                            let len = info.shareDate.length;
                            let shareDate = info.shareDate.substring(len - 2, len);
                            return shareDate === item;
                        });

                        newArr.push({
                            ...tempInfo,
                            shareDate: item,
                            shareNum: findObj ? findObj.shareNum : 0
                        })
                    })
                } else {
                    dates.forEach(item => {
                        newArr.push({
                            shareDate: item,
                            shareNum: 0
                        })
                    })
                }
                console.log(dates, newArr)
                setShareData(newArr)
            } catch (err) {
                console.log(err)
            }
        }
    }

    //根据类型获取对应日期信息
    const getDates = (type: string) => {
        let arr: string[] = [];
        switch (type) {
            case 'monthly':
                arr = mGetDate();
                break;
            case 'quarterly':
                arr = getMonth();
                break;
            case 'yearly':
                arr = ['01', "02", "03", "04", "05", "06", "07", "08", "09", "10", "11", "12"];
                break;

        };
        return arr
    }

    //获取当月份天数
    function mGetDate() {
        let days = [];
        var date = new Date();
        var year = date.getFullYear();
        var month = date.getMonth() + 1;
        var d = new Date(year, month, 0);
        for (let i = 1; i <= d.getDate(); i++) {
            days.push(`${i < 10 ? '0' + i : i}`)
        }
        return days;
    }
    //获取当前季度的月份
    function getMonth() {
        var today = new Date(); //获取当前时间
        var month = today.getMonth() + 1;//getMonth返回0-11
        if (month >= 1 && month <= 3) {
            return ["01", "02", "03"];
        } else if (month >= 4 && month <= 6) {
            return ["04", "05", "06"];
        } else if (month >= 7 && month <= 9) {
            return ["07", "08", "09"];
        } else {
            return ["10", "11", "12"];
        }
    }

    return {
        /***field***/
        loading, visitData, shareRes, orgInsertData, groupInsertData, employeeData, employeeValue, handleEmployee, shareData,
        loadVisit, loadShare, loadOrgInsert, loadGroupInsert, loadData, type, setType
    }
});